import Api from './Api'
import {store} from '../store/index'

function getOrgId() {
  return store.getters['user/getOrgContext'] || store.getters['user/getOrgId']
}

export default {
  async getEndpoint (id) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/endpoints/${id}`)
  },
  async getEndpoints (deleted) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/endpoints?deleted=${deleted}`)
  },
  async getEndpointStatuses () {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/endpoint_statuses`)
  },
  async validateEndpoint (endpoint, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''

    return new Api().post(`/admin/api/v1/orgs/${getOrgId()}/validate_endpoint${qualifier}`, endpoint)
  },
  async validateEndpointById (endpointId, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''

    return new Api().post(`/admin/api/v1/orgs/${getOrgId()}/validate_endpoint/${endpointId}${qualifier}`)
  },
  async saveEndpoint (endpoint, pwd) {
    let qualifier = pwd ? '?pwd=true' : ''

    return new Api().put(`/admin/api/v1/orgs/${getOrgId()}/endpoints${qualifier}`, endpoint)
  },
  async patchMultiple(patchlist) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/endpoints`, patchlist)
  },
  async getAllAccessGroups (deleted) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/access_groups?deleted=${deleted}`)
  },
  async getAccessGroupsForEndpointId (endpointId) {
    return new Api().get(`/admin/api/v1/endpoints/${endpointId}/access_groups`)
  },
  async getAccessGroupsForUserId (userId) {
    return new Api().get(`/admin/api/v1/users/${userId}/access_groups`)
  },
  async getAccessGroup (accessGroupId) {
    return new Api().get(`/admin/api/v1/orgs/${getOrgId()}/access_groups/${accessGroupId}`)
  },
  async saveAccessGroup(accessGroup) {
    return new Api().put(`/admin/api/v1/orgs/${getOrgId()}/access_groups`, accessGroup)
  },
  async associateAccessGroupIdsToEndpointId(endpointId, accessGroupIds) {
    return new Api().patch(`/admin/api/v1/endpoints/${endpointId}/access_groups`, accessGroupIds)
  },
  async associatedccessGroupIdsToUserId(userId, accessGroupIds) {
    return new Api().patch(`/admin/api/v1/users/${userId}/access_groups`, accessGroupIds)
  },
  async patchMultipleAccessGroups(patchlist) {
    return new Api().patch(`/admin/api/v1/orgs/${getOrgId()}/access_groups`, patchlist)
  },
  async configureXapiAdminAccounts(accessGroupId, xapiAdminProps) { //{username, password, endpoints, systemId}
    return new Api().post(`/admin/api/v1/orgs/${getOrgId()}/access_groups/${accessGroupId}/admin_users`, xapiAdminProps)
  }
}